import { Placeholder } from '../Placeholder/Placeholder';

export const ArticleCoverImageInputLoader = () => <Placeholder className="h-[300px] aspect-4/2 w-full rounded-xl" />;
